import type React from 'react';

import { Link, Text } from '@change/ds-core-ui';

import { Translate, TranslateHtml } from '@change-corgi/core-react/i18n';

import { PRESS_MAILTO_HREF } from '#src/app/pages/about/press/shared/consts';
import { GradientPanel } from '#src/app/pages/about/shared/components';

export const ContactPanel: React.FC<EmptyProps> = () => {
	return (
		<section className="container pb-16 md:pb-32">
			<GradientPanel data-qa="press-contact-panel">
				<div className="grid grid-cols-1 gap-7 md:grid-cols-2 md:gap-12" data-qa="press-contact-grid">
					<div className="flex flex-col gap-3">
						<Text as="h2" variant="heading" size="small" fontWeight="bold">
							<Translate value="corgi.press_page.contact.journalists.title" />
						</Text>
						<Text as="p" className="text-typography-weak">
							<TranslateHtml
								value="corgi.press_page.contact.journalists.body"
								replacements={{
									emailLink: (
										<Link
											href={PRESS_MAILTO_HREF}
											variant="inherit"
											size="inherit"
											bold
											data-qa="press-contact-email-link"
										>
											<Translate value="corgi.press_page.contact.journalists.email_link" />
										</Link>
									),
								}}
							/>
						</Text>
					</div>
					<div className="flex flex-col gap-3">
						<Text as="h2" variant="heading" size="small" fontWeight="bold">
							<Translate value="corgi.press_page.contact.decision_makers.title" />
						</Text>
						<Text as="p" className="text-typography-weak">
							<Translate value="corgi.press_page.contact.decision_makers.body" />
						</Text>
					</div>
				</div>
			</GradientPanel>
		</section>
	);
};
